import { render, staticRenderFns } from "./node4.vue?vue&type=template&id=34496bc4&scoped=true&"
import script from "./node4.vue?vue&type=script&lang=js&"
export * from "./node4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34496bc4",
  null
  
)

export default component.exports